<template>
  <PageWrap page-title="Empresas Tasadoras">
    <b-row>
      <b-col md="8" lg="6">
        <BfInput
          v-model="searchTerm"
          data-key="key"
          label="Búsqueda"
          placeholder="Buscar por Empresa"
          @update="updateSearch"
        />
      </b-col>
    </b-row>

    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="delegations"
      :columns="tableColumns"
      border
      @row-click="tableRowClick"
            cell-class-name="tasaciones-small-cell"

    >
      <span slot="nombre" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.nombre}}
      </span>
    </BfTable>

    <b-row class="mt-5">
      <b-col>
        <BfButton :to="{name: 'delegation'}" tag="router-link">Nueva empresa tasadora</BfButton>
      </b-col>
      <b-col class="text-right">
        <BfPagination
          v-if="delegations.length"
          :current-page="currentPage"
          :total="totalRows"
          :page-size="perPage"
          @current-change="updatePagination"
        />
      </b-col>
    </b-row>
  </PageWrap>
</template>

<script>
/* eslint-disable object-curly-newline */
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { delegationAPI } from '@/api';

export default {
  name: 'DelegationsList',

  data() {
    return {
      delegations: [],
      currentPage: 1,
      dateFrom: '',
      dateTo: '',
      loadingData: false,
      perPage: 15,
      searchTerm: '',
      totalRows: 0,
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingData = true;

      try {
        const {
          data: { data, current_page: currentPage, per_page: perPage, total },
        } = await delegationAPI.getAll({
          page: this.currentPage,
          perPage: this.perPage,
          search: this.searchTerm,
          to: this.dateTo !== '' ? this.dateTo : undefined,
        });

        this.delegations = data;
        this.totalRows = total;
        this.perPage = Number(perPage);
        this.currentPage = currentPage;
      } finally {
        this.loadingData = false;
      }
    },

    updateSearch() {
      this.loadData();
    },

    tableRowClick({ row, column }) {
      if (column.property === 'nombre') {
        const { id } = row;
        router.push({ name: 'delegation', params: { id: `${id}` } });
      }
    },

    updatePagination(newPage) {
      if (newPage !== this.currentPage) {
        this.currentPage = newPage;

        this.loadData();
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
          width: 200,
        },
        {
          label: 'Empresa',
          dataKey: 'nombre_empresa',
          sortable: true,
          width: 400,
        },
        {
          label: 'Teléfono',
          dataKey: 'telefono1',
        },
        {
          label: 'Fax',
          dataKey: 'fax',
        },
        {
          label: 'E-Mail',
          dataKey: 'email',
          sortable: true,
          width: 170,
        },
        {
          label: 'Población',
          dataKey: 'poblacion',
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
